import { render, staticRenderFns } from "./loading-screen.vue?vue&type=template&id=e551b6e4&scoped=true&"
import script from "./loading-screen.vue?vue&type=script&lang=js&"
export * from "./loading-screen.vue?vue&type=script&lang=js&"
import style0 from "./loading-screen.vue?vue&type=style&index=0&id=e551b6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e551b6e4",
  null
  
)

export default component.exports